import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import type { PartnerOrganizationManager } from "./entity";

export const PartnerOrganizationManagerEntityConfig: HyperEntityConfig<PartnerOrganizationManager> =
  {
    allowApiRead: Roles.AdminsAndManager,
    allowApiCrud: Roles.SuperAdmins,

    apiPrefilterPerRole: (filter) => {
      filter(Roles.SuperDuperAdmin, true);
      filter(Roles.SuperAdmin, true);
      filter([Roles.Admin, Roles.Manager], {
        managerId: remult.user?.id ?? "",
      });
    },

    allowInsertPerRole(allow) {
      allow(Roles.SuperAdmins, true);
    },

    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.SuperAdmins, true);
    },

    id: {
      partnerOrganizationId: true,
      managerId: true,
    },
  };
